module.exports = __webpack_public_path__ + "img/waht_eat_gif.136f3d4e.gif";